export const API_BASE_URL_DEV = 'https://staging.api.ashgridx.ashipaelectric.com';
// export const API_BASE_URL_DEV = 'http://localhost:8080';
export const API_BASE_URL_PRODUCTION = 'https://api.ashgridx.ashipaelectric.com';
export const UI_BASE_URL_DEV = 'https://staging.ashgridx.ashipaelectric.com';
// export const UI_BASE_URL_DEV = 'http://localhost:8080';
export const UI_BASE_URL_PRODUCTION = 'https://ashgridx.ashipaelectric.com';
export const API_PAGE_LIMIT = 100;
export const API_PAGE_OFFSET = 0;
export const CONSOLE_BASE_URL_DEV = 'https://staging.console.ashgridx.ashipaelectric.com';
export const CONSOLE_BASE_URL_PRODUCTION = 'https://console.ashgridx.ashipaelectric.com';
